const formatPhone = (phone: string) => {
  const a = phone.slice(0, 3);
  const b = phone.slice(3, 6);
  const c = phone.slice(6);

  return `+63 ${a} ${b} ${c}`;
};

export { formatPhone };
